import { FinnishSSN } from 'finnish-ssn';

export default {
  isValid: (value) => FinnishSSN.validate(value),
};
